<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <ui-loader v-if="isLoading" />
    <div v-if="settings && !isLoading">
      <ModalEditInvoiceSettings
        v-if="showEditSettings"
        :settings="settings"
        :showModal="showEditSettings"
        :onClickCancel="hideModal"
        @updateInvoiceSettings="updateInvoiceSettings"
      ></ModalEditInvoiceSettings>

      <ui-section-header :showEdit="!showEditSettings" :editFunction="setShowEditSettings">
      </ui-section-header>

      <div class="columns is-multiline">
        <div class="column">
          <div
            class="title is-3"
            v-text="
              $t(
                'Components.Settings.Invoice.InvoiceSettings.Title_BasicSettings'
              )
            "
          ></div>
          <table class="table is-fullwidth is-striped">
            <tbody>
              <tr>
                <td>
                  {{
                    $t('Components.Settings.Invoice.InvoiceSettings.Label_Code')
                  }}
                </td>
                <td>{{ settings.Code }}</td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_NumberLength'
                    )
                  }}
                </td>
                <td>{{ settings.NumberLength }}</td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_CodeTemplate'
                    )
                  }}
                </td>
                <td>
                  <div>{{ settings.CodeTemplate }}</div>
                  <div class="has-text-grey is-italic is-size-7">
                    {{
                      $t(
                        'Components.Settings.Invoice.InvoiceSettings.Label_Example'
                      )
                    }}
                    {{ codeTemplateExample(99) }}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_PaymentTerm'
                    )
                  }}
                </td>
                <td>{{ settings.PaymentTerm }}</td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_PaymentTermFirst'
                    )
                  }}
                </td>
                <td>{{ settings.PaymentTermFirstReminder }}</td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_PaymentTermSecond'
                    )
                  }}
                </td>
                <td>{{ settings.PaymentTermSecondReminder }}</td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_AuthorizationNeeded'
                    )
                  }}
                </td>
                <td>
                  {{
                    settings.Status === 0
                      ? $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_Yes'
                        )
                      : $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_No'
                        )
                  }}
                </td>
              </tr>
              <tr v-if="settings.Status === 0">
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_AllowSelfAuthorization'
                    )
                  }}
                </td>
                <td>
                  {{
                    settings.AllowSelfAuthorization
                      ? $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_Yes'
                        )
                      : $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_No'
                        )
                  }}
                </td>
              </tr>
              <tr v-if="settings.Status === 0">
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_NoAuthorizationWhenAmountLowerThan'
                    )
                  }}
                </td>
                <td>{{ settings.NoAuthorizationLowerThen }}</td>
              </tr>

              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_AutoRemoveUnpaidDeposit'
                    )
                  }}
                </td>
                <td>
                  {{
                    settings.AutoRemoveUnpaidDeposit
                      ? $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_Yes'
                        )
                      : $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_No'
                        )
                  }}
                </td>
              </tr>

              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_ShowBasisOnInvoice'
                    )
                  }}
                </td>
                <td>
                  {{
                    settings.ShowBasisOnInvoice
                      ? $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_Yes'
                        )
                      : $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_No'
                        )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="column">
          <div
            class="title is-3"
            v-text="
              $t(
                'Components.Settings.Invoice.InvoiceSettings.Title_EmailSettings'
              )
            "
          ></div>
          <table class="table is-fullwidth is-striped">
            <tbody>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_DefaultSenderEmailAddress'
                    )
                  }}
                </td>
                <td>{{ settings.DefaultSenderAddress }}</td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_AutoCC'
                    )
                  }}
                </td>
                <td>{{ settings.AutoCC }}</td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_AutoEmailAfterAccept'
                    )
                  }}
                </td>
                <td>
                  {{
                    settings.AutoEmailAfterAccept
                      ? $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_Yes'
                        )
                      : $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_No'
                        )
                  }}
                </td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_AutoEmailAfterCredit'
                    )
                  }}
                </td>
                <td>
                  {{
                    settings.AutoEmailAfterCredit
                      ? $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_Yes'
                        )
                      : $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_No'
                        )
                  }}
                </td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_AutoEmailFirstReminder'
                    )
                  }}
                </td>
                <td>
                  {{
                    settings.AutoEmailFirstReminder
                      ? $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_Yes'
                        )
                      : $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_No'
                        )
                  }}
                </td>
              </tr>
              <tr>
                <td>
                  {{
                    $t(
                      'Components.Settings.Invoice.InvoiceSettings.Label_AutoEmailSecondReminder'
                    )
                  }}
                </td>
                <td>
                  {{
                    settings.AutoEmailSecondReminder
                      ? $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_Yes'
                        )
                      : $t(
                          'Components.Settings.Invoice.InvoiceSettings.Label_No'
                        )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BaseInvoiceSettingsFunctions from '@/components/Settings/Invoice/BaseInvoiceSettingsFunctions.js'
import { mapMutations } from 'vuex'

const ModalEditInvoiceSettings = () =>
  import(
    /* webpackChunkName: "invoice-settings" */ '@/components/Settings/Invoice/ModalEditInvoiceSettings'
  )

export default {
  extends: BaseInvoiceSettingsFunctions,
  components: {
    ModalEditInvoiceSettings,
  },

  props: {},

  data() {
    return {
      settings: null,
      showEditSettings: false,
    }
  },

  created() {
    let self = this
    this.getLocationInvoiceSettings((response) => {
      self.settings = response
      self.setInvoiceSettings(response)
    })
  },

  methods: {
    ...mapMutations('invoiceStore', ['setInvoiceSettings']),

    codeTemplateExample(number) {
      return this.getCode(
        number,
        this.settings.NumberLength,
        this.settings.CodeTemplate,
        this.settings.Code
      )
    },

    setShowEditSettings() {
      this.showEditSettings = true
    },

    hideModal() {
      this.showEditSettings = false
    },

    /**
     * Callback: Update current invoice settings on the detail page
     */
    updateInvoiceSettings(settings) {
      this.settings = settings
    },
  },
}
</script>
